"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ValidationResultFlag_1 = require("../../core/model/errors/ValidationResultFlag"); // tslint:disable:max-classes-per-file

/**
 * @author OPt
 */
// FIXME I do not like usage of this, i would remove all of this and refactor UI logic so it uses standard way of validation msgs display

/**
 * Flag indicating Promotion date validity collision.
 */


var PromotionCollisionValidationResultFlag =
/*#__PURE__*/
function (_ValidationResultFlag) {
  _inherits(PromotionCollisionValidationResultFlag, _ValidationResultFlag);

  function PromotionCollisionValidationResultFlag() {
    _classCallCheck(this, PromotionCollisionValidationResultFlag);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromotionCollisionValidationResultFlag).apply(this, arguments));
  }

  _createClass(PromotionCollisionValidationResultFlag, [{
    key: "validate",
    value: function validate() {
      return true;
    }
  }]);

  return PromotionCollisionValidationResultFlag;
}(ValidationResultFlag_1.ValidationResultFlag);

exports.PromotionCollisionValidationResultFlag = PromotionCollisionValidationResultFlag;
PromotionCollisionValidationResultFlag.TAG = ValidationResultFlag_1.ValidationResultFlag.register(PromotionCollisionValidationResultFlag);
PromotionCollisionValidationResultFlag.INSTANCE = new PromotionCollisionValidationResultFlag();
PromotionCollisionValidationResultFlag.VALIDATION_MESSAGE_KEY = 'promotion-collision';
/**
 * Flag indicating that the PromotionArea is already in use.
 */

var PromotionAreaInUseValidationResultFlag =
/*#__PURE__*/
function (_ValidationResultFlag2) {
  _inherits(PromotionAreaInUseValidationResultFlag, _ValidationResultFlag2);

  function PromotionAreaInUseValidationResultFlag() {
    _classCallCheck(this, PromotionAreaInUseValidationResultFlag);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromotionAreaInUseValidationResultFlag).apply(this, arguments));
  }

  _createClass(PromotionAreaInUseValidationResultFlag, [{
    key: "validate",
    value: function validate() {
      return true;
    }
  }]);

  return PromotionAreaInUseValidationResultFlag;
}(ValidationResultFlag_1.ValidationResultFlag);

exports.PromotionAreaInUseValidationResultFlag = PromotionAreaInUseValidationResultFlag;
PromotionAreaInUseValidationResultFlag.TAG = ValidationResultFlag_1.ValidationResultFlag.register(PromotionAreaInUseValidationResultFlag);
PromotionAreaInUseValidationResultFlag.INSTANCE = new PromotionAreaInUseValidationResultFlag();
PromotionAreaInUseValidationResultFlag.VALIDATION_MESSAGE_KEY = 'promotion-area-in-use';
/**
 * Flag indicating that the PromotionArea is already in use.
 */

var PromotionMasterAreaInactiveValidationResultFlag =
/*#__PURE__*/
function (_ValidationResultFlag3) {
  _inherits(PromotionMasterAreaInactiveValidationResultFlag, _ValidationResultFlag3);

  function PromotionMasterAreaInactiveValidationResultFlag() {
    _classCallCheck(this, PromotionMasterAreaInactiveValidationResultFlag);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromotionMasterAreaInactiveValidationResultFlag).apply(this, arguments));
  }

  _createClass(PromotionMasterAreaInactiveValidationResultFlag, [{
    key: "validate",
    value: function validate() {
      return true;
    }
  }]);

  return PromotionMasterAreaInactiveValidationResultFlag;
}(ValidationResultFlag_1.ValidationResultFlag);

exports.PromotionMasterAreaInactiveValidationResultFlag = PromotionMasterAreaInactiveValidationResultFlag;
PromotionMasterAreaInactiveValidationResultFlag.TAG = ValidationResultFlag_1.ValidationResultFlag.register(PromotionMasterAreaInactiveValidationResultFlag);
PromotionMasterAreaInactiveValidationResultFlag.INSTANCE = new PromotionMasterAreaInactiveValidationResultFlag();
PromotionMasterAreaInactiveValidationResultFlag.VALIDATION_MESSAGE_KEY = 'promotion_master_area__area_inactive';
/**
 * Flag indicating that the Promotion has any Window.
 */

var PromotionHasWindowsValidationResultFlag =
/*#__PURE__*/
function (_ValidationResultFlag4) {
  _inherits(PromotionHasWindowsValidationResultFlag, _ValidationResultFlag4);

  function PromotionHasWindowsValidationResultFlag() {
    _classCallCheck(this, PromotionHasWindowsValidationResultFlag);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromotionHasWindowsValidationResultFlag).apply(this, arguments));
  }

  _createClass(PromotionHasWindowsValidationResultFlag, [{
    key: "validate",
    value: function validate() {
      return true;
    }
  }]);

  return PromotionHasWindowsValidationResultFlag;
}(ValidationResultFlag_1.ValidationResultFlag);

exports.PromotionHasWindowsValidationResultFlag = PromotionHasWindowsValidationResultFlag;
PromotionHasWindowsValidationResultFlag.TAG = ValidationResultFlag_1.ValidationResultFlag.register(PromotionHasWindowsValidationResultFlag);
PromotionHasWindowsValidationResultFlag.INSTANCE = new PromotionHasWindowsValidationResultFlag();
PromotionHasWindowsValidationResultFlag.VALIDATION_MESSAGE_KEY = 'promotion-has-windows';
/**
 * Flag indicating that a promotion already includes a product.
 */

var PromotionHasProductValidationResultFlag =
/*#__PURE__*/
function (_ValidationResultFlag5) {
  _inherits(PromotionHasProductValidationResultFlag, _ValidationResultFlag5);

  function PromotionHasProductValidationResultFlag() {
    _classCallCheck(this, PromotionHasProductValidationResultFlag);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromotionHasProductValidationResultFlag).apply(this, arguments));
  }

  _createClass(PromotionHasProductValidationResultFlag, [{
    key: "validate",
    value: function validate() {
      return true;
    }
  }]);

  return PromotionHasProductValidationResultFlag;
}(ValidationResultFlag_1.ValidationResultFlag);

exports.PromotionHasProductValidationResultFlag = PromotionHasProductValidationResultFlag;
PromotionHasProductValidationResultFlag.TAG = ValidationResultFlag_1.ValidationResultFlag.register(PromotionHasProductValidationResultFlag);
PromotionHasProductValidationResultFlag.INSTANCE = new PromotionHasProductValidationResultFlag();
PromotionHasProductValidationResultFlag.VALIDATION_MESSAGE_KEY = 'promotion_area__promotion_has_product';
/**
 * Flag indicating that the Promotion is locked (invalid state).
 */

var PromotionLockedValidationResultFlag =
/*#__PURE__*/
function (_ValidationResultFlag6) {
  _inherits(PromotionLockedValidationResultFlag, _ValidationResultFlag6);

  function PromotionLockedValidationResultFlag() {
    _classCallCheck(this, PromotionLockedValidationResultFlag);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromotionLockedValidationResultFlag).apply(this, arguments));
  }

  _createClass(PromotionLockedValidationResultFlag, [{
    key: "validate",
    value: function validate() {
      return true;
    }
  }]);

  return PromotionLockedValidationResultFlag;
}(ValidationResultFlag_1.ValidationResultFlag);

exports.PromotionLockedValidationResultFlag = PromotionLockedValidationResultFlag;
PromotionLockedValidationResultFlag.TAG = ValidationResultFlag_1.ValidationResultFlag.register(PromotionLockedValidationResultFlag);
PromotionLockedValidationResultFlag.INSTANCE = new PromotionLockedValidationResultFlag();
PromotionLockedValidationResultFlag.VALIDATION_MESSAGE_KEY = 'entity_locked_by_another_user';
/**
 * Flag indicating the Promotion is lock result (not necessarily invalid state).
 */

var PromotionLockSuccessValidationResultFlag =
/*#__PURE__*/
function (_ValidationResultFlag7) {
  _inherits(PromotionLockSuccessValidationResultFlag, _ValidationResultFlag7);

  function PromotionLockSuccessValidationResultFlag() {
    _classCallCheck(this, PromotionLockSuccessValidationResultFlag);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromotionLockSuccessValidationResultFlag).apply(this, arguments));
  }

  _createClass(PromotionLockSuccessValidationResultFlag, [{
    key: "validate",
    value: function validate() {
      return true;
    }
  }]);

  return PromotionLockSuccessValidationResultFlag;
}(ValidationResultFlag_1.ValidationResultFlag);

exports.PromotionLockSuccessValidationResultFlag = PromotionLockSuccessValidationResultFlag;
PromotionLockSuccessValidationResultFlag.TAG = ValidationResultFlag_1.ValidationResultFlag.register(PromotionLockSuccessValidationResultFlag);
PromotionLockSuccessValidationResultFlag.INSTANCE = new PromotionLockSuccessValidationResultFlag();
PromotionLockSuccessValidationResultFlag.VALIDATION_MESSAGE_KEY_LOCKED = 'promotions-were-locked';
PromotionLockSuccessValidationResultFlag.VALIDATION_MESSAGE_KEY_NOT_LOCKED = 'promotions-were-not-locked';
PromotionLockSuccessValidationResultFlag.VALIDATION_MESSAGE_KEY_ERROR = 'promotion-lock-error';

var PromotionInvalidStateValidationResultFlag =
/*#__PURE__*/
function (_ValidationResultFlag8) {
  _inherits(PromotionInvalidStateValidationResultFlag, _ValidationResultFlag8);

  function PromotionInvalidStateValidationResultFlag() {
    _classCallCheck(this, PromotionInvalidStateValidationResultFlag);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromotionInvalidStateValidationResultFlag).apply(this, arguments));
  }

  _createClass(PromotionInvalidStateValidationResultFlag, [{
    key: "validate",
    value: function validate() {
      return true;
    }
  }]);

  return PromotionInvalidStateValidationResultFlag;
}(ValidationResultFlag_1.ValidationResultFlag);

exports.PromotionInvalidStateValidationResultFlag = PromotionInvalidStateValidationResultFlag;
PromotionInvalidStateValidationResultFlag.TAG = ValidationResultFlag_1.ValidationResultFlag.register(PromotionInvalidStateValidationResultFlag);
PromotionInvalidStateValidationResultFlag.INSTANCE = new PromotionInvalidStateValidationResultFlag();
PromotionInvalidStateValidationResultFlag.VALIDATION_MESSAGE = 'promotion-invalid-state';

var PromotionAreaAssignValidationResultFlag =
/*#__PURE__*/
function (_ValidationResultFlag9) {
  _inherits(PromotionAreaAssignValidationResultFlag, _ValidationResultFlag9);

  function PromotionAreaAssignValidationResultFlag() {
    _classCallCheck(this, PromotionAreaAssignValidationResultFlag);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromotionAreaAssignValidationResultFlag).apply(this, arguments));
  }

  _createClass(PromotionAreaAssignValidationResultFlag, [{
    key: "validate",
    value: function validate() {
      return true;
    }
  }]);

  return PromotionAreaAssignValidationResultFlag;
}(ValidationResultFlag_1.ValidationResultFlag);

exports.PromotionAreaAssignValidationResultFlag = PromotionAreaAssignValidationResultFlag;
PromotionAreaAssignValidationResultFlag.TAG = ValidationResultFlag_1.ValidationResultFlag.register(PromotionAreaAssignValidationResultFlag);
PromotionAreaAssignValidationResultFlag.INSTANCE = new PromotionAreaAssignValidationResultFlag();
PromotionAreaAssignValidationResultFlag.VALIDATION_MESSAGE_KEY_ASSIGNED = 'promotion-area-assign';
PromotionAreaAssignValidationResultFlag.VALIDATION_MESSAGE_KEY_CAN_BE_ASSIGNED = 'promotion_master_area__area_can_be_assigned';
PromotionAreaAssignValidationResultFlag.VALIDATION_MESSAGE_KEY_NO_AREA_ASSIGNED = 'no-promotion-area-assigned';

var PromotionAreaValidationResultFlag =
/*#__PURE__*/
function (_ValidationResultFlag10) {
  _inherits(PromotionAreaValidationResultFlag, _ValidationResultFlag10);

  function PromotionAreaValidationResultFlag() {
    _classCallCheck(this, PromotionAreaValidationResultFlag);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromotionAreaValidationResultFlag).apply(this, arguments));
  }

  _createClass(PromotionAreaValidationResultFlag, [{
    key: "validate",
    value: function validate() {
      return true;
    }
  }]);

  return PromotionAreaValidationResultFlag;
}(ValidationResultFlag_1.ValidationResultFlag);

exports.PromotionAreaValidationResultFlag = PromotionAreaValidationResultFlag;
PromotionAreaValidationResultFlag.TAG = ValidationResultFlag_1.ValidationResultFlag.register(PromotionAreaValidationResultFlag);
PromotionAreaValidationResultFlag.INSTANCE = new PromotionAreaValidationResultFlag();

var PromotionValidationResultFlag =
/*#__PURE__*/
function (_ValidationResultFlag11) {
  _inherits(PromotionValidationResultFlag, _ValidationResultFlag11);

  function PromotionValidationResultFlag() {
    _classCallCheck(this, PromotionValidationResultFlag);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromotionValidationResultFlag).apply(this, arguments));
  }

  _createClass(PromotionValidationResultFlag, [{
    key: "validate",
    value: function validate() {
      return true;
    }
  }]);

  return PromotionValidationResultFlag;
}(ValidationResultFlag_1.ValidationResultFlag);

exports.PromotionValidationResultFlag = PromotionValidationResultFlag;
PromotionValidationResultFlag.TAG = ValidationResultFlag_1.ValidationResultFlag.register(PromotionValidationResultFlag);
PromotionValidationResultFlag.INSTANCE = new PromotionValidationResultFlag();